import {
  GroupObjects,
  LockOutline,
  UngroupObjects,
  UnlockOutline,
} from '../../../utils/editorReactIcons';

/**
 * One lock/unlock and one group/ungroup action for the current selection
 * (same rules as the floating toolbar).
 */
const buildGroupLockContextualButtons = (api) => {
  const buttons = [];

  if (api.floatingLockAction === 'unlock') {
    buttons.push({
      id: 'unlock',
      titleKey: 'unlockSelectionTitle',
      labelKey: 'unlockShort',
      Icon: UnlockOutline,
      onClick: api.unlock,
    });
  } else if (api.floatingLockAction === 'lock') {
    buttons.push({
      id: 'lock',
      titleKey: 'lockSelectionTitle',
      labelKey: 'lockShort',
      Icon: LockOutline,
      onClick: api.lock,
    });
  }

  if (api.floatingGroupAction === 'ungroup') {
    buttons.push({
      id: 'ungroup',
      titleKey: 'ungroupSelectionTitle',
      labelKey: 'ungroupShort',
      Icon: UngroupObjects,
      onClick: api.ungroup,
    });
  } else if (api.floatingGroupAction === 'group') {
    buttons.push({
      id: 'group',
      titleKey: 'groupSelectionTitle',
      labelKey: 'groupShort',
      Icon: GroupObjects,
      onClick: api.group,
    });
  }

  return buttons;
};

export default buildGroupLockContextualButtons;
